export const ANGULAR_PREFIX = '#!';
